import React, { useEffect, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { ScrollArea } from "../ui/scroll-area";
import { Button } from "../ui/button";
import { Clock } from "lucide-react";

const TimePicker = ({ setTime }) => {
  const [hour, setHour] = useState("00");
  const [minute, setMinute] = useState("00");
  const [period, setPeriod] = useState("AM");

  const hours = Array.from({ length: 12 }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );
  const minutes = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, "0")
  );

  const display = `${hour}:${minute} ${period}`;

  useEffect(() => {
  const h = parseInt(hour, 10);   // convert "05" → 5
  const m = parseInt(minute, 10); // convert "07" → 7
  let calculatedHour = h;

  // Convert to 24-hour format
  if (period === "PM" && h !== 12) {
    calculatedHour = h + 12; // 1PM → 13
  } else if (period === "AM" && h === 12) {
    calculatedHour = 0; // 12AM → 00
  }

  const formattedHours = String(calculatedHour).padStart(2, "0");
  const formattedMinutes = String(m).padStart(2, "0");

  setTime(`${formattedHours}:${formattedMinutes}`);
}, [hour, minute, period]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="w-full flex items-center justify-between rounded-md px-4 py-2 bg-background text-foreground text-sm h-12">
          <span>{display}</span>
          <Clock size={16} />
        </button>
      </PopoverTrigger>

      <PopoverContent className="w-auto p-4 bg-background text-foreground border rounded-xl shadow-xl" align="start">
        <div className="flex gap-2">
          <div className="flex flex-col gap-1">
            <span className="text-[10px] font-bold text-center text-muted-foreground">HRS</span>
            <ScrollArea className="h-40 w-14 rounded-md border">
              {hours.map((h) => (
                <div
                  key={h}
                  onClick={() => setHour(h)}
                  className={`px-2 py-1.5 cursor-pointer text-center text-sm ${hour === h ? "bg-button-coloured text-button-coloured-foreground" : "hover:bg-accent hover:text-black-primary"}`}
                >
                  {h}
                </div>
              ))}
            </ScrollArea>
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-[10px] font-bold text-center text-muted-foreground">MIN</span>
            <ScrollArea className="h-40 w-14 rounded-md border">
              {minutes.map((m) => (
                <div
                  key={m}
                  onClick={() => setMinute(m)}
                  className={`px-2 py-1.5 cursor-pointer text-center text-sm ${minute === m ? "bg-button-coloured text-button-coloured-foreground" : "hover:bg-accent hover:text-black-primary"}`}
                >
                  {m}
                </div>
              ))}
            </ScrollArea>
          </div>
          <div className="flex flex-col gap-1 pt-5">
            {["AM", "PM"].map((p) => (
              <Button
                key={p}
                onClick={() => setPeriod(p)}
                className={`w-full py-2 rounded-md border
                ${period === p ? "bg-button-coloured" : "text-button-generic-foreground bg-button-generic hover:text-white dark:hover:text-black-primary"}`}
              >
                {p}
              </Button>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default TimePicker
